export const HISTORY_LOOKBACK_DAYS = [1, 3, 5, 7] as const;
export const HISTORY_MESSAGES_PER_DAY = 30;

export type HistoryLookbackDays = (typeof HISTORY_LOOKBACK_DAYS)[number];

export function isHistoryLookbackDays(value: number): value is HistoryLookbackDays {
  return HISTORY_LOOKBACK_DAYS.some((days) => days === value);
}
